import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.571 17",
  "aria-labelledby": "icon-title"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.321 0v4.25h4.25z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M9.463 5.108a1.211 1.211 0 0 1-.356-.858V0H1.214A1.215 1.215 0 0 0 0 1.214v14.571A1.215 1.215 0 0 0 1.214 17h12.143a1.215 1.215 0 0 0 1.214-1.214V5.464h-4.25a1.211 1.211 0 0 1-.858-.356M3.44 7.511h4.509v1.215H3.44zm7.691 6.034H3.439v-1.214h7.692zm0-2.41H3.439V9.921h7.692z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };